import { Link } from 'react-router-dom';
import { BsPersonWorkspace } from 'react-icons/bs';
import { FaUser } from 'react-icons/fa';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IoMdRefresh } from 'react-icons/io';
import {
  getDashboardMemberSummary,
  getMember,
} from '../../../redux/MainAction';

const WorkRoles = () => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const members = useSelector((state) => state.Webtracker.member?.rows);

  const memberSummary = useSelector(
    (state) => state.Webtracker.dashboardMemberSummary
  );

  async function fetchDashboardData() {
    setIsLoading(true);
    setFirstRefresh(true);

    await dispatch(getDashboardMemberSummary());
    await dispatch(getMember({ offset: 0, limit: 5, showArchived: false }));

    setIsLoading(false);
  }

  return (
    <div className="col-6">
      <div className="card  m-b-20 enhanced-card">
        <div className="border_class d-flex align-items-center justify-content-between">
          <h5 className="dash-card-title font-20 ml-3">New Members</h5>
        </div>

        <div className="card-body dash_cards act_card1">
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="spinner-border text-primary " role="status"></div>
            </div>
          ) : firstRefresh ? (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ color: '#23486A', fontSize: '18px' }}>
                  <BsPersonWorkspace className="font-20  mr-2 dash-text-primary" />{' '}
                  {memberSummary?.workspaceName}
                </h6>
                <Link
                  to="/members"
                  className="font-14 btn btn-primary"
                  style={{ cursor: 'pointer' }}
                >
                  Show All
                </Link>
              </div>

              <div className="table-responsive pb-2 mt-3">
                <table className="table table-vertical mb-0 border-collapse">
                  <thead>
                    <tr>
                      <th className="font-14 py-1">Name</th>
                      <th className="font-14 text-right py-1">Role</th>
                    </tr>
                  </thead>
                  <tbody className="table_scroll">
                    {members?.map((member, idx) => (
                      <tr key={idx}>
                        <td className="font-14 py-1">
                          <FaUser className="mr-2 text-primary" />
                          {member?.firstName} {member?.lastName}
                        </td>
                        <td className="font-14 text-right py-1">
                          <span
                            className={
                              member?.userEmployeeRelation?.role ===
                              'PROJECT-MANAGER'
                                ? 'text_style bg-purple'
                                : member?.userEmployeeRelation?.role ===
                                    'TEAM-MANAGER'
                                  ? 'text_style bg-info'
                                  : 'text_style3'
                            }
                          >
                            {member?.userEmployeeRelation?.role === 'EMPLOYEE'
                              ? 'Employee'
                              : member?.userEmployeeRelation?.role}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <button
                className="btn btn-primary font-14"
                onClick={() => fetchDashboardData(true)}
              >
                Load Data
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkRoles;
